exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg[data-v-7b9c051c]{animation:2s linear infinite svg-animation-7b9c051c;max-width:100px}@keyframes svg-animation-7b9c051c{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}circle[data-v-7b9c051c]{animation:1.4s ease-in-out infinite both circle-animation-7b9c051c;display:block;fill:transparent;stroke:currentColor;stroke-linecap:round;stroke-dasharray:283;stroke-dashoffset:280;stroke-width:10px;transform-origin:50% 50%}@keyframes circle-animation-7b9c051c{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}to{stroke-dashoffset:280;transform:rotate(1turn)}}", ""]);

// exports
